import { all } from '@redux-saga/core/effects';
import signInSaga from './SignIn';
import signOutSaga from './SignOut';
import registerSaga from './Register';
import routingSaga from './Routing';
import MarketingPreferencesSaga from './MarketingPreferences';
import modalSaga from './Modal';
import recaptchaSaga from './Recaptcha';
import socialSaga from './Social';

function* rootSaga() {
  yield all([
    signInSaga(),
    registerSaga(),
    MarketingPreferencesSaga(),
    modalSaga(),
    signOutSaga(),
    recaptchaSaga(),
    routingSaga(),
    socialSaga(),
  ]);
}

export default rootSaga;
